import Typography from "@mui/material/Typography";
import { FC } from "react";

// Read out, not drawn: pages whose design has no visible title still need their one h1.
const VISUALLY_HIDDEN = {
  position: "absolute",
  width: 1,
  height: 1,
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  whiteSpace: "nowrap",
} as const;

const PageHeading: FC<{ text: string }> = ({ text }) =>
  text ? (
    <Typography component="h1" sx={VISUALLY_HIDDEN}>
      {text}
    </Typography>
  ) : null;

export default PageHeading;
